<template>
  <validation-observer v-slot="{ handleSubmit }">
    <div class="modal-card enhancify grid-module unsubscribers">
      <header class="modal-card-head">
        <h2 class="modal-card-title">{{ unsubscribe ? 'Unsubscribe'
          : 'Resubscribe' }}</h2>
        <button class="modal-close is-large" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <validation-provider v-slot="{ errors }" name="E-mail" rules="required|email">
            <b-field v-model="email"
                     label="E-mail"
                     :type="{ 'is-danger': errors.length }"
                     :message="errors + [ '&nbsp;' ]">
              <b-input v-model="email"
                       maxlength="255"
                       @blur="()=>{ trimSpaces('email') }"></b-input>
            </b-field>
          </validation-provider>
        </form>
      </section>
      <footer class="modal-card-foot buttons is-right">
          <button class="button button-cancel" type="button"
                  @click="cancel">{{ 'cancel' | upper}}</button>
          <button class="button is-success"
                  @click="handleSubmit(submit)">{{ (unsubscribe
              ? 'unsubscribe' : 'resubscribe') | upper }}</button>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { get } from 'lodash';
import { mapMutations } from 'vuex';
import { unsubscribe, resubscribe } from '@/api/emails';
import * as MUTATIONS from '../../store/mutations';

export default {
  name: 'EmailUnsubscribers',
  props: ['unsubscribe'],
  data() {
    return {
      email: '',
    };
  },

  methods: {
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),

    submit() {
      this.preloader(true);
      const submitFn = () => (this.unsubscribe
        ? unsubscribe({ email: this.email, source: 'manual' })
        : resubscribe({ email: this.email }));

      submitFn().then(() => {
        this.$emit('submit', { context: this });
        this.$emit('close');
      }).catch((err) => {
        const error = get(err, 'response.data.error', null);
        const message = get(err, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com');
        if (error) {
          this.$buefy.toast.open({ message, type: 'is-danger', duration: 3000 });
        } else {
          this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com' });
        }
      })
        .finally(() => this.preloader(false));
    },
    cancel() {
      this.$emit('close');
    },
    trimSpaces(field) {
      this[field] = this[field].replace(/([\s]+)/gu, ' ').replace(/^[\s]|[\s]$/gu, '');
    },

  },
};
</script>

<style scoped lang="stylus">
.modal-card
  .modal-card-title
    margin-bottom 0
    font-size 30px
.modal-card.grid-module.unsubscribers
  height unset
.modal-card-body >>> label.label
  font-weight 400
.buttons:last-child
  margin-bottom unset

footer.modal-card-foot
  padding 12px
  justify-content end
button.button
  width 135px
  height 46px
  border 1px solid #23D160
  font-size 19px
  text-transform uppercase
  margin-bottom 0
.button.button-cancel
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white
.button.is-success
  border none

</style>
